// extracted by mini-css-extract-plugin
export default {"header":"Oq","fullPage":"Pq","closed":"Qq","minimize":"Rq","redcircle":"Sq","container":"Tq","text":"Uq","centered":"Vq","escapex":"Wq"};
    if(module.hot) {
      // 1714442366298
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  